module.exports = __webpack_public_path__ + "static/media/BE.8e6fc60f.svg";